module.exports = __webpack_public_path__ + "img/usb-sticker.fc3391d0.png";